import { Html, OrbitControls } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import React, { useEffect, useRef } from 'react';
import { Vector3 } from 'three';
import TWEEN from 'tween';
import { useShallow } from 'zustand/react/shallow';
import HolesLoader from '../../loaders/HolesLoader.js';
import LoadModel from '../../loaders/LoadModel.js';
import { ModelListBR } from "../../Utils/ModelsList.js";
import CameraControl from '../../clickTools/CameraControl.js';
import MeasureLines from '../../clickTools/MeasureLines.js';
import { useClickStore, useInforStore } from '../../store/clickStore.js';
import BlockModels from '../../loaders/BlockModels.js';
import AssayLoader from '../../loaders/AssayLoaderTM.js';
import HoleRender from '../../loaders/holeTools/HoleRender.js';
import AnimatedObject from '../../Utils/AnimatedObject.js';
import PlannedHoles from '../../loaders/PlannedHoles.js';

const SceneComponent = ({ layerVisibility, cameraPosition, lookAt, animateCamera ,currentSlide , onThreeReady}) => {
  const { camera, gl, scene, raycaster } = useThree()
  const controlRef = useRef()

  const constants_ = [0,0,0]

  const {setInfo} =    useInforStore(useShallow((state)=>({
      setInfo:state.setInfo
  })))

  const {setClickParams} = useClickStore(useShallow((state)=>({        
      setClickParams:state.setClickParams
  })))
  useEffect(()=>{
    onThreeReady({ camera, gl, scene, raycaster , controlRef })
      console.log('Experience rerendered')
  },[])

  const manage_click=(e)=>{
      console.log(e,e.point,e.object,e.instanceId)
      setClickParams(e.point,e.object,e.instanceId)
      setInfo(e.object?e.object.name+`   coords:X:${(e.point.x+constants_[0]).toFixed(1)} Y:${(-(e.point.z-constants_[1]).toFixed(1))} Z:${(e.point.y+constants_[2]).toFixed(1)}`:'...')
      e.stopPropagation()    
      console.log('camera pos-',camera.position , 'LookAt',controlRef.current.target)    
  }

  
  useEffect(() => {
    if (animateCamera) {
      // If animation is required, tween the camera position and look-at target
      const endPosition = new Vector3(...cameraPosition);
      const endLookAt = new Vector3(...lookAt);

      new TWEEN.Tween(camera.position)
        .to(endPosition, 5000) // Duration of animation in milliseconds
        .easing(TWEEN.Easing.Cubic.Out) // Easing function for smoothness
        .start();

      new TWEEN.Tween(controlRef.current.target)
        .to(endLookAt, 5000) // Duration should match position tween
        .easing(TWEEN.Easing.Cubic.Out)
        .start();

    } else {
      // If no animation, set immediately
      camera.position.set(...cameraPosition);
      controlRef.current.target.set(...lookAt);
    }
  }, [currentSlide]);

  // Update tweens on each frame
  useFrame(() => {
    TWEEN.update();
    // sconsole.log('camera pos-',camera.position , 'LookAt',controlRef.current.target)
  });

  return (
    <>  
      <directionalLight position={[1,200,-300]} intensity={2.5}/>
      <directionalLight position={[1,200,300]} intensity={2.5}/>
      <ambientLight intensity={1.5}/> 
      <OrbitControls makeDefault ref={controlRef}/>
      <MeasureLines />
      {/* <AnimatedObject/> */}
      {/* Conditionally render objects based on visibleObjects */}
      <group onClick={(e)=>{ manage_click(e)} } >
      {ModelListBR.map((group) =>
        group.models.map((model) => {
          const modelState = layerVisibility[model.name];
          console.log('model',model.name,model)
          if (modelState) {
            return (
              (model.type && model.type=='holes')?
              <HolesLoader key={model.name} name={model.name} url={model.url} dataset={model.dataset} holetype={model.holetype} visible={modelState.visible}/>
              :
              (model.type && model.type=='blockmodel')?
              <BlockModels key={model.name} url={model.url} name={model.name} dx={model.dx} dy={model.dy} dz={model.dz} size={model.size} grade={model.grade} bmvisible={modelState.visible} />
              :
              (model.type && model.type==='assays')?
              <AssayLoader key={model.name} name={model.name} url={model.url} visible={modelState.visible}/>
              :
              (model.type && model.type==='holesassays')?
              <HoleRender key={model.name} name={model.name} hole_url={model.hole_url} assay_url={model.assay_url}  visible={modelState.visible}/>
              :
              (model.type && model.type==='animation')?
              <AnimatedObject key={model.name} name={model.name}  visible={modelState.visible}/>
              :
              (model.type && model.type==='plannedholes')?
              <PlannedHoles key={model.name} name={model.name} url={model.url} dataset={model.dataset} color={model.color} visible={modelState.visible}/>
              :
              <LoadModel key={model.name} name={model.name} url={model.url} visible={modelState.visible} {...(model.rotation ? { rotation: model.rotation } : {})} {...(model.translation ? { translation: model.translation } : {})}/>
            );
          }
          return null;
        })
      )}
      </group>
      <CameraControl controls={controlRef}/>
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} intensity={0.5} />  
      <Levels/>  
    </>  
  );
};

function Levels() {
  // const { camera } = useThree()
  // const [isVisible, setIsVisible] = useState(true);

  
  const {showLabels} = useClickStore()

  var levels = [
      ["2L",1120],
      ["3L",1086],
      ["4L",1055],
      ["5L",1013],
      ["6L",934],
      ["7L",888],
      ["8L",847],
      ["9L",801],
      ["10L",754],
      ["11L",667],
      ["12L",595],
      ["13L",522],
      ["14L",445],
      ["15L",375],
      ["16L",305],
      ["17L",235],
      ["18L",165],
      ["19L",95],
      ["20L",25],
      ["SEA LEVEL",0],
      ["21L",-45],
      ["22L",-115],
      ["23L",-185],
      ["24L",-255]
  ]

  // useFrame(({ camera }) => {
  //     const distance = camera.position.distanceTo(new Vector3(205650-205200, 800-1180, 7975000-7975010));
  //     setIsVisible(distance <= 5000);
  //     //console.log('distance checked',distance,distance <= 2000)
  //   });

  return (
      <>
         {showLabels && levels.map((a, i) => {
              return (
                  <Html 
                      key={i} 
                      position={[205650-205200, a[1]-1180, 7975000-7975010]}
                      occlude="blending"
                      center
                      transform
                      sprite
                      distanceFactor={500}
                      >
                      <div className="levels" onClick={() => console.log('.')}>
                          {a[0] + '-' + (1180-a[1])+'m (' + a[1]+'RL)'} 
                      </div>
                      
                  </Html>
              )
          })
          }
      </>
  )
}

export default SceneComponent;
